import React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const PluginSnackbar = ({ open, message, severity, onClose }) => {
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        if(onClose) onClose();
    };
    // const action = (
    //     <React.Fragment>
    //         <Button color="secondary" size="small" onClick={handleClose}>
    //             UNDO
    //         </Button>
    //         <IconButton
    //             size="small"
    //             aria-label="close"
    //             color="inherit"
    //             onClick={handleClose}
    //         >
    //             <CloseIcon fontSize="small" />
    //         </IconButton>
    //     </React.Fragment>
    // );
    return (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity={severity ? severity : 'success'}
                variant="filled"
                sx={{ width: '100%', bgcolor: "#198754" }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default PluginSnackbar;
